import Swal from 'sweetalert2';
import manager from 'app/module46/component-manager.js';

manager.register('table-modal', (component, elements, attributes, properties) => {
	const touchModes = {
		none: 0,
		drag: 1,
		zoom: 2,
	};
	let selectAreaUrl = null;
	let addCartUrl = null;
	let createUrl = null;
	let canvas = null;
	let showZonesBtn;
	let showMyZonesBtn;
	let showSelectorBtn;
	let body = document.getElementsByTagName("BODY")[0];
	let captureBtn;
	let zoomUpBtn;
	let zoomDownBtn;
	let ctx;
	let img = document.createElement("img");
	// let zoom;
	let x;
	let y;
	let mouseX;
	let mouseY;
	let touchX;
	let touchY;
	let backgroundOffsetX;
	let backgroundOffsetY;
	let targetOffsetX;
	let targetOffsetY;
	let imageWidth;
	let imageHeight;
	let centerShiftX;
	let centerShiftY;
	let isSubscriber;
	let userSelect;

	let width;
	let height;
	let scale;
	let drawing = false;
	let moving = false;
	let movingTarget = false;
	let targetX;
	let targetY;
	let centerX;
	let centerY;
	let relativeRadius;
	let maxX;
	let maxY;
	let targetRadius;
	let targetWidth;
	let zoomedOutX;
	let zoomedOutY;
	let zoomedOutRadius;
	let zoomeOutWidth;
	let defaultThickness = 5;
	let cursorX;
	let cursorY;
	let showZones;
	let showMyZones;
	let showZoomedOutTarget;
	let showSelector;
	let touchDistance;

	let touchMode = touchModes.none;
	let factor;
	const myScreenshots = [];

	const {
		type,
		image,
		// title,
		cursorDiameter,
		tableId,
		kioskId,
		showZoneText,
		hideZoneText,
		showMyZonesText,
		hideMyZonesText,
		showSelectorText,
		hideSelectorText,
		subscriberId
	} = properties;

	let {
		existingScreenshots,
	} = properties;

	let cartCountEl = document.querySelector('.cart-btn .cart-btn__count');

	existingScreenshots = Object.values(existingScreenshots);

	for (const existingScreenshot of existingScreenshots) {
		if (existingScreenshot.subscriber_id === subscriberId) {
			myScreenshots.push(existingScreenshot);
		}
	}

	const {
		table
	} = elements;

	img.src = image;

	// If type subscriber
	isSubscriber = type === 'subscriber';
	if (isSubscriber) {
		({selectAreaUrl, addCartUrl, createUrl} = properties);
	}

	const html = document.getElementById('table').innerHTML;

	table.addEventListener('click', () => {
		showTableModal();
	});

	relativeRadius = cursorDiameter / 2;


	function showZonesEventListener() {
		showZones = !showZones;

		showZonesBtn.innerHTML = showZones ?
			hideZoneText :
			showZoneText;

		requestAnimationFrame(drawContents);
	}

	const showMyZonesEventListener = () => {
		showMyZones = !showMyZones;

		showMyZonesBtn.innerHTML = showMyZones ?
			hideMyZonesText :
			showMyZonesText;

		requestAnimationFrame(drawContents);
	};

	const mouseMoveListener = (e) => {
		if (moving) {
			const newMouseX = e.offsetX / factor;
			const newMouseY = e.offsetY / factor;

			if (movingTarget) {
				targetX = Math.min(Math.max(targetX - (mouseX - newMouseX), relativeRadius), maxX);
				targetY = Math.min(Math.max(targetY - (mouseY - newMouseY), relativeRadius), maxY);
				// targetX -= mouseX - e.offsetX;
				// targetY -= mouseY - e.offsetY;

			} else {
				backgroundOffsetX -= mouseX - newMouseX;
				backgroundOffsetY -= mouseY - newMouseY;
			}

			mouseX = newMouseX;
			mouseY = newMouseY;


			requestAnimationFrame(drawContents);
		}
	};

	const mouseDownListener = (e) => {
		mouseX = e.offsetX / factor;
		mouseY = e.offsetY / factor;

		userSelect = body.style.userSelect;
		body.style.userSelect = 'none';
		canvas.style.cursor = 'none';

		let distance = Math.sqrt(Math.pow(mouseX - targetX, 2) + Math.pow(mouseY - targetY, 2));

		movingTarget = distance < relativeRadius;

		moving = true;
	};

	const mouseUpListener = () => {
		body.style.userSelect = userSelect;
		canvas.style.cursor = 'move';
		moving = false;
	};

	const zoomUpListener = (e) => {
		e.stopPropagation();

		scaleFn(Math.min(Math.max(scale + 0.250, 1), 5));
	};

	const zoomDownListener = (e) => {
		e.stopPropagation();

		scaleFn(Math.min(Math.max(scale - 0.250, 1), 5));
	};

	const wheelListener = (e) => {
		e.preventDefault();

		scaleFn(Math.min(Math.max(scale + (-0.125 * (e.deltaY / 100)), 1), 5));
	};

	const scaleFn = (tempScale) => {
		backgroundOffsetX /= scale;
		backgroundOffsetY /= scale;
		cursorX /= scale;
		cursorY /= scale;
		scale = tempScale;
		backgroundOffsetX *= scale;
		backgroundOffsetY *= scale;
		cursorX *= scale;
		cursorY *= scale;

		requestAnimationFrame(drawContents);
	};

	function showSelectorListener() {
		showSelector = !showSelector;

		showSelectorBtn.innerHTML = showSelector ?
			hideSelectorText :
			showSelectorText;

		requestAnimationFrame(drawContents);
	}

	const resizeObserver = new ResizeObserver((entries) => {
		for (const entry of entries) {

			if (entry.contentBoxSize) {
				// Firefox implements `contentBoxSize` as a single content rect, rather than an array
				const contentBoxSize = Array.isArray(entry.contentBoxSize) ?
					entry.contentBoxSize[0] :
					entry.contentBoxSize;

				const resizeWidth = contentBoxSize.inlineSize;
				canvas.width = resizeWidth;

				if (resizeWidth !== 1600) {
					factor = canvas.width / 1600;

				} else {
					factor = 1;
				}

				canvas.height = 900 * factor;

				ctx.resetTransform();
				ctx.scale(factor, factor);
				requestAnimationFrame(drawContents);
			}
		}
	});


	function drawContents() {
		drawing = true;
		const newWidth = width * scale;
		const newHeight = height * scale;
		const factX = ((newWidth - width) / -2) + (backgroundOffsetX);
		const factY = ((newHeight - height) / -2) + (backgroundOffsetY);

		cursorX = centerX - (backgroundOffsetX / scale) - ((centerX - targetX) / scale);
		cursorY = centerY - (backgroundOffsetY / scale) - ((centerY - targetY) / scale);

		targetRadius = (relativeRadius / newWidth) * width;
		targetWidth = (defaultThickness / newWidth) * width;

		ctx.clearRect(0, 0, width, height);
		ctx.fillRect(0, 0, width, height);

		ctx.save();
		ctx.translate(factX, factY);
		ctx.scale(scale, scale);

		ctx.drawImage(img, centerShiftX, centerShiftY, imageWidth, imageHeight);

		if (showZones) {
			for (const circle of existingScreenshots) {
				ctx.beginPath();
				ctx.lineWidth = circle.thickness;
				ctx.strokeStyle = "#f0ad4e";
				ctx.arc(circle.pos_x, circle.pos_y, circle.radius, 0, 2 * Math.PI);
				ctx.stroke();
			}
		}

		if (showMyZones) {
			for (const circle of myScreenshots) {
				ctx.beginPath();
				ctx.lineWidth = circle.thickness;
				ctx.strokeStyle = "#004FFF";
				ctx.arc(circle.pos_x, circle.pos_y, circle.radius, 0, 2 * Math.PI);
				ctx.stroke();
			}
		}

		if (showZoomedOutTarget) {
			ctx.beginPath();
			ctx.lineWidth = zoomeOutWidth;
			ctx.strokeStyle = "#004FFF";
			ctx.arc(zoomedOutX, zoomedOutY, zoomedOutRadius, 0, 2 * Math.PI);
			ctx.stroke();
		}

		ctx.restore();

		if (isSubscriber && showSelector && !showZoomedOutTarget) {
			ctx.beginPath();
			ctx.lineWidth = defaultThickness;
			ctx.strokeStyle = "#ee2547";
			ctx.arc(targetX, targetY, relativeRadius, 0, 2 * Math.PI);
			ctx.stroke();
		}

		drawing = false;
	}

	function fit(parentWidth, parentHeight, childWidth, childHeight, offsetX = 0.5, offsetY = 0.5) {
		const childRatio = childWidth / childHeight;
		const parentRatio = parentWidth / parentHeight;
		imageWidth = childWidth;
		imageHeight = childHeight;

		if (childRatio > parentRatio) {
			imageWidth = parentWidth;
			imageHeight = imageWidth / childRatio;
		} else {
			imageHeight = parentHeight;
			imageWidth = imageHeight * childRatio;
		}

		centerShiftX = (parentWidth - imageWidth) * offsetX;
		centerShiftY = (parentHeight - imageHeight) * offsetY;
	}

	function cropImageArea() {
		const tempShowZones = showZones;
		const tempShowMyZones = showMyZones;
		const tempShowSelector = showSelector;
		showZones = false;
		showMyZones = false;
		showSelector = true;

		requestAnimationFrame(() => {
			drawContents();

			requestAnimationFrame(() => {
				canvas.toBlob((blob) => {
					captureFullSizeTableImage(blob, tempShowZones, tempShowMyZones, tempShowSelector);
				});
			});
		});
	}

	function captureFullSizeTableImage(blob, tempShowZones, tempShowMyZones, tempShowSelector) {
		const tempScale = scale;
		const tempBackgroundOffsetX = backgroundOffsetX;
		const tempBackgroundOffsetY = backgroundOffsetY;
		const tempTargetOffsetX = targetOffsetX;
		const tempTargetOffsetY = targetOffsetY;

		showZoomedOutTarget = true;
		zoomedOutX = cursorX;
		zoomedOutY = cursorY;
		zoomedOutRadius = targetRadius;
		zoomeOutWidth = targetWidth;
		scale = 1;
		backgroundOffsetX = 0;
		backgroundOffsetY = 0;

		requestAnimationFrame(() => {
			drawContents();

			requestAnimationFrame(() => {
				canvas.toBlob((fullSizeBlob) => {
					scale = tempScale;
					backgroundOffsetX = tempBackgroundOffsetX;
					backgroundOffsetY = tempBackgroundOffsetY;
					targetOffsetX = tempTargetOffsetX;
					targetOffsetY = tempTargetOffsetY;

					showZoomedOutTarget = false;
					showZones = tempShowZones;
					showMyZones = tempShowMyZones;
					showSelector = tempShowSelector;
					requestAnimationFrame(drawContents);

					/*console.log({
						cursorX,
						cursorY,
						targetRadius,
						targetWidth
					});*/

					manager.api(selectAreaUrl, {
						cursorX: zoomedOutX,
						cursorY: zoomedOutY,
						targetRadius: zoomedOutRadius,
						targetWidth: zoomeOutWidth,
						tableId,
						kioskId,
						blob,
						fullSizeBlob,
					}, ({screenshotId, screenshotSrc}) => {
						showConfirmModal(screenshotId, screenshotSrc);
					}, () => {
						// silent catch
					});
				});
			});
		});
	}

	function showConfirmModal(screenshotId, screenshotSrc) {
		const confirmationHtml = document.getElementById('confirmation').innerHTML;

		Swal.fire({
			title: 'Confirmation',
			html: confirmationHtml,
			showConfirmButton: false,
			showCloseButton: true,
			didClose: showTableModal,
			customClass: {
				popup: "screenshot__confirmation"
			},
			didOpen: (popup) => {
				const btnStartChat = popup.getElementsByClassName('startCommunication')[0];
				const btnAddCart = popup.getElementsByClassName('addCart')[0];
				// const imageThumbnail = popup.getElementsByClassName('screenshot__confirmation-thumbnail')[0];

				// imageThumbnail.src = screenshotSrc;

				btnStartChat.addEventListener('click', function () {
					manager.api(addCartUrl, {
						screenshotId: screenshotId,
						tableId: tableId,
					}, () => {
						startCommunication(screenshotId);
					});
				});

				btnAddCart.addEventListener('click', function () {
					manager.api(addCartUrl, {
						screenshotId: screenshotId,
						tableId: tableId,
					}, (response) => {
						const cartTitle = response.title;
						const cartMessage = response.message;

						if (response.itemCount && cartCountEl) {
							cartCountEl.innerHTML = response.itemCount;
						}

						const circle = {
							pos_x: cursorX,
							pos_y: cursorY,
							thickness: targetWidth,
							radius: targetRadius,
						};

						existingScreenshots.push(circle);
						myScreenshots.push(circle);

						Swal.fire({
							icon: 'success',
							title: cartTitle,
							text: cartMessage,
							showConfirmButton: false,
							showCloseButton: true,
							didClose: showTableModal,
						});
					}, () => {
						// Already firing a modal based on response.message
					});
				});
			}
		});
	}

	function touchStartListener(e) {
		e.preventDefault();
		touchMode = e.targetTouches.length;

		if (touchMode === touchModes.drag) {
			const touch = e.targetTouches[0];
			const canvasRect = canvas.getBoundingClientRect();

			touchX = (touch.clientX - canvasRect.x) / factor;
			touchY = (touch.clientY - canvasRect.y) / factor;

			let distance = Math.sqrt(Math.pow(touchX - targetX, 2) + Math.pow(touchY - targetY, 2));

			movingTarget = distance < relativeRadius;

		} else if (touchMode === touchModes.zoom) {
			const firstTouch = e.targetTouches[0];
			const secondTouch = e.targetTouches[1];

			touchDistance = Math.sqrt(Math.pow(firstTouch.clientX - secondTouch.clientX, 2)
				+ Math.pow(firstTouch.clientY - secondTouch.clientY, 2));
		}
	}

	function touchMoveListener(e) {
		e.preventDefault();

		if (touchMode === touchModes.drag) {
			const touch = e.targetTouches[0];
			const canvasRect = canvas.getBoundingClientRect();

			const newX = (touch.clientX - canvasRect.x) / factor;
			const newY = (touch.clientY - canvasRect.y) / factor;

			if (movingTarget) {
				targetX = Math.min(Math.max(targetX - (touchX - newX), relativeRadius), maxX);
				targetY = Math.min(Math.max(targetY - (touchY - newY), relativeRadius), maxY);

			} else {
				backgroundOffsetX -= touchX - newX;
				backgroundOffsetY -= touchY - newY;
			}

			touchX = newX;
			touchY = newY;


			requestAnimationFrame(drawContents);

		} else if (touchMode === touchModes.zoom) {
			const firstTouch = e.targetTouches[0];
			const secondTouch = e.targetTouches[1];

			const newDistance = Math.sqrt(Math.pow(firstTouch.clientX - secondTouch.clientX, 2)
				+ Math.pow(firstTouch.clientY - secondTouch.clientY, 2));

			const zoomFact = (newDistance - touchDistance) / 100;
			scaleFn(Math.min(Math.max(scale + zoomFact, 1), 5));

			touchDistance = newDistance;
		}
	}

	function touchEndListener(e) {
		e.preventDefault();
		touchMode = e.targetTouches.length;

		if (touchMode === touchModes.drag) {
			const touch = e.targetTouches[0];
			const canvasRect = canvas.getBoundingClientRect();

			touchX = (touch.clientX - canvasRect.x) / factor;
			touchY = (touch.clientY - canvasRect.y) / factor;

			let distance = Math.sqrt(Math.pow(touchX - targetX, 2) + Math.pow(touchY - targetY, 2));

			movingTarget = distance < relativeRadius;

		} else if (touchMode === touchModes.none) {

		}
	}

	function showTableModal() {
		Swal.fire({
			title: null,
			html,
			showConfirmButton: false,
			showCloseButton: true,
			customClass: {
				popup: "table-swal",
				container: "table-swal",
			},
			willOpen: (popup) => {
				canvas = popup.getElementsByClassName('table__canvas')[0];
				showZonesBtn = popup.getElementsByClassName('table__show_zones')[0];
				showMyZonesBtn = popup.getElementsByClassName('table__show_my_zones')[0];
				showSelectorBtn = popup.getElementsByClassName('table__show_selector')[0];
				captureBtn = popup.getElementsByClassName('table__capture_btn')[0];
				zoomUpBtn = popup.getElementsByClassName('table__zoom_up_btn')[0];
				zoomDownBtn = popup.getElementsByClassName('table__zoom_down_btn')[0];
				ctx = canvas.getContext('2d');


				canvas.width = 1600;
				canvas.height = 900;
				resizeObserver.observe(canvas);

				fit(canvas.width, canvas.height, img.width, img.height);
				// fit(1600, 900, img.width, img.height);

				// zoom = document.getElementById('zoom');
				// x = document.getElementById('x');
				// y = document.getElementById('y');

				if (isSubscriber) {
					captureBtn.addEventListener('click', cropImageArea);

					showSelectorBtn.innerHTML = hideSelectorText;
					showSelectorBtn.addEventListener('click', showSelectorListener);

					showMyZonesBtn.innerHTML = showMyZonesText;
					showMyZonesBtn.addEventListener('click', showMyZonesEventListener);

				} else {
					// zoom.style.display = "none";
					// x.style.display = "none";
					// y.style.display = "none";
					showSelectorBtn.style.display = "none";
					showMyZonesBtn.style.display = "none";
					// zoomUpBtn.style.display = "none";
					// zoomDownBtn.style.display = "none";
					captureBtn.style.display = "none";
				}

				showZonesBtn.innerHTML = showZoneText;
				showZonesBtn.addEventListener('click', showZonesEventListener);

				canvas.addEventListener('wheel', wheelListener);
				canvas.addEventListener('mousedown', mouseDownListener);
				canvas.addEventListener('mousemove', mouseMoveListener, true);
				document.addEventListener('mouseup', mouseUpListener);
				zoomUpBtn.addEventListener('click', zoomUpListener);
				zoomDownBtn.addEventListener('click', zoomDownListener);

				canvas.addEventListener('touchstart', touchStartListener);
				canvas.addEventListener('touchmove', touchMoveListener);
				canvas.addEventListener('touchend', touchEndListener);

				width = 1600;
				height = 900;
				maxX = width - relativeRadius;
				maxY = height - relativeRadius;
				targetX = centerX = width / 2;
				targetY = centerY = height / 2;
				scale = 1;
				backgroundOffsetX = 0;
				backgroundOffsetY = 0;
				targetOffsetX = 0;
				targetOffsetY = 0;
				showZones = false;
				showMyZones = false;
				showZoomedOutTarget = false;
				showSelector = true;

				ctx.scale(factor, factor);

				requestAnimationFrame(drawContents);

			}
		}).then(() => {
			resizeObserver.unobserve(canvas);
		});
	}

	/**
	 * @param screenshot_id
	 */
	function startCommunication(screenshot_id) {

		manager.api(createUrl, {
				type: 'zoom',
				screenshot_id,
				subject: 'product',
			},
			({callingId}) => {
				if (callingId) {
					// Send communication id to refresher (flap.js)
					window.setCalling(true, callingId);
				}
			}
		);
	}
});
